import * as React from 'react'
import * as classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

import HouseIcon from './house.svg?reactCompornt'
import PhoneIcon from './phone.svg?reactCompornt'
import StarIcon from './star.svg?reactCompornt'

import * as Style from './style.css'

const REVIEW_TYPE_SUPPORT = 'support'
const REVIEW_TYPE_CONSULTATION = 'consultation'

export interface IProps {
  type: typeof REVIEW_TYPE_SUPPORT | typeof REVIEW_TYPE_CONSULTATION
  score: number
  count: number
}

export const Review = ({ type, score, count }: IProps): JSX.Element => (
  <span className={Style.Review}>
    <span className={Style.Title}>レビュー</span>
    {count !== 0 && (
      <>
        <span className={Style.Score}>
          <StarIcon />
          {score}
        </span>
        <span className={Style.Count}>({count}件)</span>
      </>
    )}
    {count === 0 && <span className={Style.NoScore}>未評価</span>}
  </span>
)
